<template>
	<div class="ProductListAssembly" v-infinite-scroll="loadMore" infinite-scroll-immediate="false" infinite-scroll-distance = "80" infinite-scroll-delay="100">
		<!-- <span>{{hasProduct}}</span> -->
		<ul v-if="hasProduct" class="ProductListAssemblyList">
			
			<li @click="toShopList(item.bizId,item.faceImg,item.productUrl,item.type)" v-for="(item,index) in ProductListAssemblyList" :key="index" class="clearfix">
				<div class="dsLine" v-if="item.isDianShang">
					<span>------------电商------------</span>
				</div>
				<div v-else>
					<div class="ProductListAssemblyPic"><img :src="item.faceImg" alt=""></div>
					<div class="ProductListAssemblyMes">
						<div class="ProductListAssemblyTit">{{item.description}}</div>
						<div class="ProductListAssemblyName">
							<span>{{item.title}}</span>
							<div v-if="noDistance">
								<div v-if="item.kilometers > 1" class="distance">{{item.kilometers.toFixed(1)}}km</div>
								<div v-else class="distance">
									<span v-if="item.kilometers">{{(item.kilometers*1000).toFixed(0)}}m</span>
									<span v-else></span>
								</div>
							</div>
						</div>
							
						<div class="price"><span>￥</span>{{item.salePrice/100}}    <span style="text-decoration: line-through;color: #999999;font-size: 0.24rem;">门市价：￥{{item.originPrice/100}}</span></div>
						<div class="buyBtn">立即购买</div>
					</div>
				</div>
				
			</li>
		</ul>
		
		<div v-else class="noProduct">
			暂无活动
		</div>
		
		
	</div>
	
	
	
</template>

<script>
	import Vue from 'vue';
	
	export default {
		name: "home",
		components: {
			
		},
		props: ['typeName'],
		data() {
			return {
				"ProductListAssemblyList":[],
				"loading":true,
				"hasProduct":true,
				
				"productType":1,
				
				"page":0,
				"lat":"",
				"lon":"",
				"isBook":1,
				"menuId":"",
				"menuLevel":"",
				
				"filterType":1,
				"noDistance":true,
				
				"description":''
				
			}
		},
		activated() {

		},
		created() {
			console.log(this.typeName)
			
		},
		mounted() {
			var that = this;
			that.loadMore();
		},
		methods: {
			defImg() { // 图片加载失败时加载占位图
				let img = event.srcElement;
				img.src = this.defaultImg;
				img.onerror = null; //防止闪图
			},
			getProduct() { //获取活动
				var that = this;
				
				if (that.menuId == 45) {
					that.http.getDSProduct({
						"page":that.page,
						"limit":10,
						"sourceType":localStorage.getItem("sourceType"),
					}).then((res) => {
						const count = parseInt(res.data.count);
						
						if (count == 0 && that.page<2) {
							that.hasProduct = false;
						}
						if (res.data.data) {
							that.ProductListAssemblyList.push(...res.data.data);
							if (res.data.data.length < 10) {
								that.loading = false;
							}
							
						}
						
						// that.ProductListAssemblyList.push(...res.data.data);
						
					})
					return;
				}
				
				let areaName = "";
				if (that.menuId != 4) {
					areaName = localStorage.getItem("areaName")||"";
				}
				that.http.getQueryProduct({
					"lat":that.lat,
					"lon":that.lon,
					"limit":10,
					"page":that.page,
					"isBook":that.isBook,
					"menuId":that.menuId,
					"menuLevel":that.menuLevel,
					"description":that.description,
					"sourceType":localStorage.getItem("sourceType"),
					"areaName":areaName
				}).then((res) => {
					console.log(res.data);
					const count = parseInt(res.data.count);
					
					if (count == 0 && that.page<2) {
						that.hasProduct = false;
					}
					
					console.log(count);
					if (res.data.data) {
						that.ProductListAssemblyList.push(...res.data.data);
						if (res.data.data.length < 10) {
							that.loading = false;
							
							
							that.http.getDSProduct({
								"page":1,
								"limit":50,
								"sourceType":localStorage.getItem("sourceType"),
							}).then((res) => {
								console.log(res.data);
								const count = parseInt(res.data.count);
								that.ProductListAssemblyList.push({"isDianShang":true});
								that.ProductListAssemblyList.push(...res.data.data);
								
							})
							
						}
						
					}
					
					
				})
				
			},
			toShopList(bizId,shopPic,shopLink,type){
				sessionStorage.setItem("shopPic",shopPic);
				sessionStorage.setItem("shopLink",shopLink);
				window.location.href = shopLink;
				
			},
			loadMore(){
				var that = this;
				if (that.loading == false) {
					return;
				}
				that.page = that.page + 1;
				
				that.isBook = that.typeName.isBook;
				that.description = that.typeName.description;
				
				if (that.typeName.type == 1) {		//销量
					that.lat = "";
					that.lon = "";
					that.noDistance = false;
				} else{
					that.lat = localStorage.getItem("locationLat");
					that.lon = localStorage.getItem("locationLon");
					that.noDistance = true;
				}
				console.log(that.typeName,"11111111111111");
				if (that.typeName.menuId) {
					that.menuId = that.typeName.menuId;
					// that.menuLevel = that.typeName.menuLevel;
					that.menuLevel = localStorage.getItem("menuLevel");
				} else{
					that.menuId = "";
					that.menuLevel = "";
				}
				// that.lat = localStorage.getItem("locationLat");
				// that.lon = localStorage.getItem("locationLon");
				that.getProduct();
			},
			
		},
		watch:{
			filterType:function (val) {
				console.log(val,"llllllllllllll")
			}
		}

	};
</script>

<style scoped lang="scss">
	// .ProductListAssembly::-webkit-scrollbar {
	//   display: none; /* Chrome Safari */
	// }
	.ProductListAssembly {
		// background-color: #f9f9f9;
		height: 100%;
		overflow: auto;
		// scrollbar-width: none; /* firefox */
		// -ms-overflow-style: none; /* IE 10+ */
		
		
		.ProductListAssemblyList {
			text-align: left;
		
			li {
				background-color: #fff;
				border-radius: 0.14rem;
				margin-bottom: 0.26rem;
				box-shadow: 0px 0px 0.24rem rgb(0 0 0 / 3%);
				
				
				.dsLine{
					position: relative;
					text-align: center;
					color: #998c8c;
					height: 0.5rem;
					line-height: 0.5rem;
					letter-spacing: 1px;
					
					span{
						position: absolute;
						top: 50%;
						left: 50%;
						width: 7.5rem;
						height: 100%;
						transform: translate(-50%,-50%);
						background-color: #f9f9f9;
						z-index: 2;
					}
				}
		
				.ProductListAssemblyPic {
					width: 100%;
					height: 3.3rem;
					// background-color: #afafaf;
					border-top-left-radius: 0.14rem;
					border-top-right-radius: 0.14rem;
					overflow: hidden;
					position: relative;
					
					img{
						position: absolute;
						height: auto;
						width: 100%;
						min-height: 3.2rem;
						top: 50%;
						left: 0;
						transform: translateY(-50%);
					}
				}
		
				.ProductListAssemblyMes {
					width: 100%;
					position: relative;
					padding: 0.2rem 0.2rem 0.8rem;
		
					.ProductListAssemblyTit {
						font-size: 0.28rem;
						font-weight: bold;
						color: #1c1c1c;
						line-height: 0.38rem;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box; // 作为弹性伸缩盒子模型显示。
						-webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
						-webkit-line-clamp: 3; // 显示的行
						text-align: justify;
					}
		
					.ProductListAssemblyName {
						color: rgba(28, 28, 28, 0.6);
						font-size: 0.24rem;
						margin-top: 0.14rem;
						position: relative;
						display: -webkit-box; // 作为弹性伸缩盒子模型显示。
						-webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式--从上到下垂直排列
						-webkit-line-clamp: 1; // 显示的行
						text-align: justify;
						line-height: 0.32rem;
						padding-right: 1.3rem;
						overflow: hidden;
		
						.distance {
							position: absolute;
							right: 0;
							top: 0;
							height: 0.2rem;
							color: rgba(28, 28, 28, 0.6);
						}
					}
		
					.price {
						position: absolute;
						font-size: 0.36rem;
						color: #f73030;
						font-weight: bold;
						left: 0.2rem;
						bottom: 0.2rem;
						
					}
		
					.buyBtn {
						position: absolute;
						bottom: 0.2rem;
						right: 0.2rem;
						width: 1.24rem;
						height: 0.4rem;
						line-height: 0.4rem;
						background-image: linear-gradient(270deg,
							#ff5b23 0%,
							#fb8d17 100%),
							linear-gradient(#e2373d,
							#e2373d);
						border-radius: 100px;
						text-align: center;
						color: #fff;
						font-size: 0.24rem;
					}
				}
		
			}
		
		
		
		}
		
		.noProduct{
			text-align: center;
			font-size: 0.36rem;
			color: #999999;
			font-weight: bold;
			padding-top: 2rem;
			letter-spacing: 0.06rem;
		}
	}
</style>
